import SignStep from './components/SignStep.jsx';
import ESignApplicationContainer from './ESignApplicationContainer.jsx';
import { PDFProvider } from './eSignPDFContext.tsx';

export default function ESignSignPage() {
  return (
    <ESignApplicationContainer>
      <PDFProvider>
        <SignStep />
      </PDFProvider>
    </ESignApplicationContainer>
  );
}
